import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as _ from 'lodash-es';

@Component({
    selector: 'app-pin-entry',
    templateUrl: './pin-entry.component.html',
    styleUrls: ['./pin-entry.component.css']
})
export class PinEntryComponent implements OnInit {

    @Output() enter = new EventEmitter<string>();

    get masked() {
        return _.join(_.map(this.inputAmount, __ => '*'), '');
    }

    inputAmount = '';

    constructor(
    ) { }

    doClear() {
        this.inputAmount = '';
    }

    ngOnInit(): void {
    }

    onDigit(d: string) {
        if (!_.isNaN(+d)) {
            // append digit
            this.inputAmount += d;
        } else {
            const s = this.inputAmount;
            const ss = s.slice(0, -1);
            if (ss) {
                this.inputAmount = ss
            } else {
                this.doClear();
            }
        }
    }

    onConfirm() {
        if (this.inputAmount.length >= 4) {
            this.enter.emit(this.inputAmount);
        }
    }
}
